import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_DIAGRAM_ID = 'diagramId'

export const processFlowsSearchParams = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_SITE_ID]: z.string(),
})

export const processFlowDiagramSearchParams = processFlowsSearchParams.extend({
  [SEARCH_PARAM_DIAGRAM_ID]: z.string(),
})

export const createProcessFlowsSearch = ({
  orgId,
  siteId,
}: {
  orgId: string | undefined
  siteId: string
}) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})

export const createProcessFlowDiagramSearch = ({
  orgId,
  siteId,
  diagramId,
}: {
  orgId: string | undefined
  siteId: string
  diagramId: string
}) => ({
  ...createProcessFlowsSearch({
    orgId,
    siteId,
  }),
  [SEARCH_PARAM_DIAGRAM_ID]: diagramId,
})
